import Axios, { AxiosRequestConfig } from 'axios';
import { appConfig } from 'config/appConfig';
import { showError } from 'utils/showError';

const baseURL: string = appConfig.apiBaseUrl;
const axiosClient = Axios.create({
  baseURL,
  timeout: 10 * 60 * 1000, // timeout in ms
} as AxiosRequestConfig);

axiosClient.interceptors.request.use(
  (config) => {
    config.params = config.params || {};

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (401 === error.response?.status) {
      sessionStorage.removeItem('jwt');
      showError('Your session expired, please login again');
      window.location.href = appConfig.loginUrl;
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

export { axiosClient };
